import {
  Button,
  Col,
  DatePicker,
  Divider,
  Input,
  Radio,
  Row,
  Typography,
  Upload,
  message,
  Spin,
  Form,
  Flex,
  FormInstance,
  Modal,
  FloatButton
} from "antd";
import { CalculatorOutlined, QuestionCircleOutlined, DeleteOutlined, PlusOutlined, CloseOutlined, CopyOutlined, SaveOutlined } from "@ant-design/icons";
import { ReactComponent as CalendarIcon } from "../assets/calendar-icon.svg";
import { ReactComponent as SoundIcon } from "../assets/sound-icon.svg";
import { ReactComponent as VideoIcon } from "../assets/video-icon.svg";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { CustomUpload } from "../components/CustomUpload";
import { PhotoDisplay } from "../components/photo/PhotoDisplay.jsx";
import { AudioDisplay } from "../components/AudioDisplay";
import { ActionType } from "../components/ActionType";
import Pricelist from "../components/priceList/Pricelist";
import { gethealtechConfig } from "../config/config";
import dayjs from "dayjs";
import { Confirm } from "../components/Confirm";
import { useMqtt } from "../context/MqttContext";
import { RadioChangeEvent } from "antd/es/radio/interface";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDemand, ACTIONS } from "../context/DemandContext";
import { useSaveOperation } from "../hooks/demand/useSaveOperation";
import { useDemandFormFileManagement } from "../hooks/demand/useDemandFormFileManagement";
import { useDemandDataLoader } from "../hooks/demand/useDemandDataLoader";
import { AudioSection } from "../components/audio/AudioSection";
import { PhotoSection } from "../components/photo/PhotoSection";
import { useVersionControl } from '../hooks/demand/useVersionControl';
import { usePriceCalculation } from '../hooks/demand/usePriceCalculation';
const { Title, Text } = Typography;

interface ExampleItem {
  id: number;
  title: string;
  content: string;
}

interface ExampleList {
  public: ExampleItem[];
  family: ExampleItem[];
  farewell: ExampleItem[];
}

const exampleList: ExampleList = {
  public: [
    {
      id: 1,
      title: "範例一",
      content: "親愛的家人和朋友們，此刻我用另一種方式陪伴著你們。回顧我的人生，雖然不能說完美無缺，但我為曾經擁有的一切感到無比幸福。\n\n謝謝我的家人，無論順境還是逆境，始終陪伴在我的身邊，給予我無盡的支持與愛；謝謝我的朋友，曾與我共享歡笑與淚水，豐富了我的人生。\n\n從今天起，我將化作微風、陽光，悄悄守護著你們。請別太難過，擦乾眼淚，帶著笑容繼續前行。生命的價值不在於長短，而是珍惜當下以及與所愛之人共度美好時光。\n\n感謝你們為我做的一切，也謝謝你們來送我最後一程。我已準備好踏上新的旅程，而你們的愛，將一直與我同在。\n\n珍重再見，願我們有緣再相逢。"
    },
    {
      id: 2,
      title: "範例二",
      content: "大家好，我是○○○，是○○○、○○○的超級老媽，更是○○○的妻子。\n\n各位親友，感謝你們今天特地來到這裡，送我最後一程。請不要為我流太多眼淚，因為我現在已經沒有病痛了。我會在天上保佑你們大家，未來你們一定要互相照顧並且平安、健康！\n\n我的這一生，有家人和你們的陪伴，已經非常幸福了。這47年來，我們一起經歷了很多酸甜苦辣，攜手建立了一個完整而幸福的家。謝謝你這麼多年來的包容與陪伴，讓我的生命充滿了愛與溫暖。\n\n現在我離開了，你們一定要好好照顧自己，別太累，也別讓自己過得太苦。日子還長，記得替我多看看這個世界，好好陪伴我們的孩子，幫我照顧好這個家，我永遠愛你們。"
    }
  ],
  family: [
    {
      id: 1,
      title: "範例一",
      content: "親愛的家人，我在另一個世界，向你們訴說我的思念與感謝。\n\n媽媽，從我來到這個世界的那一刻起，你就給了我無私的愛。你總是默默地為我付出，無論我做了什麼，你都包容我、支持我。媽媽請不要太過悲傷，未來的日子裡，請好好照顧自己，別再為我勞累了。\n\n爸爸，你的肩膀曾是我依靠的港灣，你的教誨讓我成長為一個有擔當的人。謝謝你總是以沉穩的力量守護著我們的家。爸爸，你是我的榜樣，我知道你會堅強面對一切。\n\n(兄弟姐妹)，你是我最牽掛的家人之一。從小到大，你都是我心中那個充滿笑容的小女孩。哥沒能陪你走更長的路，真的很抱歉，但我希望你知道，無論你在哪裡，我都會守護著你。\n\n(感情伴侶)，謝謝你走進我的生命，雖然我們的故事比預期短暫，但每一段回憶都珍貴無比。我希望你能記住我們在一起的美好，而不是沉浸在離別的痛苦中。我會在另一個地方為你祈福，希望你能遇見屬於你的幸福，繼續勇敢地愛與被愛。\n\n我親愛的家人與愛人，雖然我的身體已離開，但我的心從未遠去。我會以另一種形式，繼續守護你們。好好地活下去，好好地愛彼此。永遠愛你們的○○○"
    },
    {
      id: 2,
      title: "範例二",
      content: "老公啊，47年的感情早就刻在我們的生命裡了，我雖然不在，但這份牽掛永遠不會離開你。以後的日子，我會以另一種方式陪著你，你一定要堅強振作起來，記得身體一定要顧好，別讓我擔心。\n\n兒子啊，媽媽這輩子最驕傲的，就是看著你成長，變成一個懂事、有擔當的男人。雖然媽媽不在了，但你要記得，男人的肩膀是用來扛責任的，也別忘了，累了的時候，家永遠是你的避風港。\n\n女兒啊，從小媽媽看著你一步步長大，變成一個堅強又貼心的小寶貝，心裡真的特別欣慰。以後媽媽不在了，你要記得不管遇到什麼，家人永遠是你最好的依靠。\n\n媽媽希望你們都能開心地過好每一天，這就是我最大的心願，我永遠愛你們。"
    }
  ],
  farewell: [
    {
      id: 1,
      title: "範例一",
      content: "各位親愛的家人朋友們，今天我用另一種方式，來和你們說一聲感謝，也說一聲再見。我的一生因為有你們的陪伴，讓我的每一天都充滿了色彩。\n\n每一次和朋友的聚會，每一場和家人的爭吵後的和好，每一個你們給我的擁抱和鼓勵，都是我生命中最珍貴的回憶。\n\n這些點點滴滴，我都會好好地收藏起來，帶著它們繼續走向我的下一段旅程。\n\n我知道我的離開會讓你們感到難過，但我希望這段悲傷不會停留太久。請記得那些我們開心的時光，因為這些才是真正屬於我們的故事。\n\n(家人1)、(家人2)、(家人3)、(親密關係1)、(摯友)、(摯友2)，我永遠感激你們無條件的愛與支持，讓我成為現在的我。親愛的朋友們，謝謝你們讓我的人生充滿驚喜與溫暖。\n\n最後，請讓我們用一個笑容，告別今天的眼淚。我走得很快樂，因為有你們的愛，讓我的人生毫無遺憾。而你們才是我生命中最重要的寶藏。\n\n謝謝大家，珍重再見。"
    },
    {
      id: 2,
      title: "範例二",
      content: "感謝大家在我的人生中，帶來那麼多的歡笑和陪伴。你們的關心與支持，讓我的生活更加豐富。\n\n我雖然離開了，但你們的友誼和愛，我都帶走了，永存於心。\n\n請大家不要為我難過太久。我希望你們記得的，是我笑著的模樣，記得那些屬於我們的快樂時光。\n\n再未來的日子裡，每當你們回憶起時，你們臉上都是帶著笑容，因為我曾經是你們生命的一部分，而你們，也讓我的人生圓滿無憾。\n\n謝謝大家，珍重再見。"
    }
  ]
};

// 新增動作相關的介面定義
interface ActionItem {
  id: string;
  order: number;
  files: {
    my: { photo: any[] };
    created: { video: any[] };
  };
  settings: {
    videoFormat: string;
    lipSync: string;
  };
  action: string | null;
  moreText: string | null;
  hint: string | null;
  reverseHint: string | null;
}

interface ActionTypeValues {
  action: string;
  moreText?: string;
  hint?: string;
  reverseHint?: string;
}

interface FormContainerProps {
  children: React.ReactNode;
}

interface VideoPriceProps {
  title: string;
  cost: number;
  time: string;
}

interface ActionPriceProps {
  title: string;
  cost: number;
}

const DemandForm: React.FC = () => {
  const navigate = useNavigate();
  const { demandId: urlDemandIdParam } = useParams<{ demandId?: string }>();
  const [form] = Form.useForm();

  // 🎯 Context 狀態管理 (主要數據源)
  const { state, dispatch } = useDemand();

  // 🚀 保存操作 Hook
  const { save, isLoading: isSaving, error: saveError, progress: saveProgress } = useSaveOperation();

  // 🎯 檔案管理 Hook
  const {
    handleUpload,
    handleRemove,
    handleAudioDurationChange,
    fileState,
    demandState
  } = useDemandFormFileManagement();

  // 🎯 費用試算 Hook
  const {
    priceList,
    mediaDurations,
    cost,
    showCostCalculation,
    isPriceListLoading,
    handleCostCalculation,
    fetchPriceList,
    setShowCostCalculation,
    hasAnyMedia
  } = usePriceCalculation();

  // 🎯 數據載入 Hook
  const {
    isLoading: isLoadingDemand,
    error: loadError,
    loadDemandData,
    clearError
  } = useDemandDataLoader();

  // 🎯 字段變化處理函數
  const handleBasicFieldChange = useCallback((field: string, value: any) => {
    dispatch({
      type: ACTIONS.UPDATE_BASIC_FIELD,
      payload: { field, value }
    });
  }, [dispatch]);

  const handleScriptChange = useCallback((section: string, script: string) => {
    dispatch({
      type: ACTIONS.UPDATE_SCRIPT,
      payload: { section, script }
    });
  }, [dispatch]);

  const handleNotesChange = useCallback((notes: string) => {
    dispatch({
      type: ACTIONS.UPDATE_NOTES,
      payload: notes
    });
  }, [dispatch]);

  // 台詞狀態直接從 Context 獲取，用於驗證和UI

  const [formType, setFormType] = useState<string>("首次填寫");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const [showPricelistModal, setShowPricelistModal] = useState<boolean>(false);

  // 需求單編號 Modal 狀態
  const [demandIdModalVisible, setDemandIdModalVisible] = useState<boolean>(false);
  const [demandIdForModal, setDemandIdForModal] = useState<string>("");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const urlDemandId = urlDemandIdParam || urlParams.get('id') || '';

  const {
    version,
    updateVersionControl,
    sourceJsonFileId,
    currentVersionNumber,
    totalVersions
  } = useVersionControl();

  // 移除重複的 useItemQuery 邏輯，統一使用 useDemandDataLoader

  // 複製需求單編號功能
  const handleCopyDemandId = async () => {
    try {
      console.log('[DemandForm] handleCopyDemandId', demandIdForModal);
      await navigator.clipboard.writeText(demandIdForModal);
      message.success('需求單編號已複製到剪貼板！');
    } catch (error) {
      // 如果 clipboard API 不可用，使用備用方法
      const textArea = document.createElement('textarea');
      textArea.value = demandIdForModal;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        message.success('需求單編號已複製到剪貼板！');
      } catch (fallbackError) {
        message.error('複製失敗，請手動複製需求單編號');
      }
      document.body.removeChild(textArea);
    }
  };



  // 🎯 從 URL 參數自動載入需求單數據
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    const loadDataFromUrl = async () => {
      if (urlDemandId && !hasLoadedRef.current) {
        console.log('[DemandForm] 從 URL 載入需求單:', urlDemandId);
        hasLoadedRef.current = true;

        try {
          // 清除之前的錯誤
          clearError();

          // 自動設置為重複編輯模式
          setFormType("重複編輯");
          form.setFieldsValue({
            formType: "重複編輯",
            demandId: urlDemandId
          });

          // 載入需求單數據
          const success = await loadDemandData(urlDemandId);
          if (success) {
            message.success('需求單數據載入成功！');
          }
        } catch (error) {
          console.error('[DemandForm] 載入數據時發生錯誤:', error);
          hasLoadedRef.current = false; // 重置狀態以允許重試
        }
      }
    };

    loadDataFromUrl();
  }, [urlDemandId]); // 只依賴 urlDemandId

  const { publish } = useMqtt();

  const calculateCost = (audioSeconds: number): { price: number, time: string } => {
    // 如果沒有音頻，則返回零價格
    if (audioSeconds === 0) {
      return {
        price: 0,
        time: "尚未上傳音頻"
      };
    }

    const minutes = audioSeconds / 60;
    let videoItemIndex = 0;

    // 根據音頻長度劃分區段
    if (minutes <= 3) {
      videoItemIndex = 0; // 3分鐘(含)內
    } else if (minutes <= 5) {
      videoItemIndex = 1; // 3~5分鐘
    } else if (minutes <= 10) {
      videoItemIndex = 2; // 5~10分鐘
    } else {
      videoItemIndex = 3; // 10分鐘以上
    }

    // 從價目表獲取價格
    const videoPrice = priceList.videoItems[videoItemIndex]?.price || 25000;
    const timeText = priceList.videoItems[videoItemIndex]?.spec || "3分鐘(含)內";

    return {
      price: videoPrice,  // 改為只返回一個價格
      time: timeText
    };
  };



  // 🎯 確認提交處理函數（顯示確認 Modal）
  const handleConfirmSubmit = async (): Promise<void> => {
    try {
      // 先進行表單驗證
      await form.validateFields();

      // 檢查現有項目和版本信息
      await checkexistingItem();

    } catch (error: any) {
      if (error?.errorFields) {
        // 表單驗證錯誤處理
        const firstErrorField = error.errorFields[0];
        const fieldName = Array.isArray(firstErrorField?.name)
          ? firstErrorField.name[0]
          : firstErrorField?.name;

        console.log('驗證錯誤:', {
          errorFields: error.errorFields,
          firstErrorField,
          fieldName
        });

        if (fieldName) {
          // 嘗試跳轉到欄位
          try {
            form.scrollToField(fieldName, {
              behavior: 'smooth',
              block: 'center'
            });
            console.log(`嘗試跳轉到欄位: ${fieldName}`);
          } catch (scrollError) {
            console.warn(`跳轉到欄位 ${fieldName} 失敗:`, scrollError);

            // 如果 scrollToField 失敗，嘗試手動跳轉
            const element = document.querySelector(`[data-field="${fieldName}"]`) ||
              document.querySelector(`#${fieldName}`) ||
              document.querySelector(`[name="${fieldName}"]`);

            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
              console.log(`手動跳轉到欄位 ${fieldName} 成功`);
            } else {
              console.warn(`找不到欄位 ${fieldName} 的 DOM 元素`);
            }
          }
        }

        // 顯示具體的錯誤訊息
        const errorMessage = firstErrorField?.errors?.[0] || '請檢查表單填寫是否完整!';
        message.error(errorMessage);
      }
    }
  };

  // 🎯 實際儲存處理函數（確認後執行）
  const handleSubmit = async (): Promise<void> => {
    try {
      // 🎯 數據來源從 Context，使用 useSaveOperation 保存
      // useSaveOperation 已包含完整的保存流程，包括：
      // - 版本控制檢查
      // - 數據驗證
      // - 檔案上傳
      // - 項目創建/更新
      // - 錯誤處理
      const saveResult = await save();

      // 發送 MQTT 消息
      publish('eternal/demand', {
        action: 'fronted send data',
      });

      // 打開彈窗modal, 提醒用戶記住需求單編號
      if (saveResult && saveResult.success && saveResult.demandId) {
        setDemandIdForModal(saveResult.demandId);
        
        // 🎯 將訂單資訊存到 localStorage，參考 Member 頁面格式
        const memberInfo = {
          projectName: saveResult.demandId,
          loginTime: new Date().toLocaleString("zh-TW"),
        };
        localStorage.setItem("memberInfo", JSON.stringify(memberInfo));
        
        setDemandIdModalVisible(true);
      }

    } catch (error: any) {
      console.error('儲存錯誤:', error);
      // 錯誤處理已經在 useSaveOperation 中處理
    } finally {
      setConfirmOpen(false);
    }
  };



  const onFinishFailed = (errorInfo: any) => {
    console.log("Form validation failed:", errorInfo);

    if (errorInfo?.errorFields?.length > 0) {
      const firstErrorField = errorInfo.errorFields[0];
      const fieldName = Array.isArray(firstErrorField?.name)
        ? firstErrorField.name[0]
        : firstErrorField?.name;

      console.log('表單驗證失敗:', {
        errorFields: errorInfo.errorFields,
        firstErrorField,
        fieldName
      });

      // 跳轉到第一個錯誤欄位
      if (fieldName) {
        try {
          form.scrollToField(fieldName, {
            behavior: 'smooth',
            block: 'center'
          });
          console.log(`嘗試跳轉到欄位: ${fieldName}`);
        } catch (scrollError) {
          console.warn(`跳轉到欄位 ${fieldName} 失敗:`, scrollError);

          // 如果 scrollToField 失敗，嘗試手動跳轉
          const element = document.querySelector(`[data-field="${fieldName}"]`) ||
            document.querySelector(`#${fieldName}`) ||
            document.querySelector(`[name="${fieldName}"]`);

          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
            console.log(`手動跳轉到欄位 ${fieldName} 成功`);
          } else {
            console.warn(`找不到欄位 ${fieldName} 的 DOM 元素`);
          }
        }
      }

      // 顯示具體的錯誤訊息
      const errorMessage = firstErrorField?.errors?.[0] || '請檢查表單填寫是否完整!';
      message.error(errorMessage);
    }
  };

  const handleExampleClick = (type: keyof ExampleList, exampleId: number) => {
    const example = exampleList[type].find((item: ExampleItem) => item.id === exampleId);
    console.log('範例:', example);
    if (!example) return;

    // 設置表單值
    switch (type) {
      case 'public':
        form.setFieldsValue({ publicScript: example.content });
        // 手動更新 Context 狀態
        handleScriptChange('public', example.content);
        break;
      case 'family':
        form.setFieldsValue({ familyScript: example.content });
        // 手動更新 Context 狀態
        handleScriptChange('family', example.content);
        break;
      case 'farewell':
        form.setFieldsValue({ farewellScript: example.content });
        // 手動更新 Context 狀態
        handleScriptChange('farewell', example.content);
        break;
    }
  };

  const getActionText = (action: string) => {
    switch (action) {
      case 'sit':
        return '坐下';
      case 'stand':
        return '站起';
      case 'turn':
        return '轉身';
      case 'bow':
        return '揖手';
      case 'salute':
        return '敬禮';
      case 'other':
        return '';
      default:
        return '';
    }
  };



  // 搜索功能 (使用新的方式)
  const handleSearch = async (isSetFormData = false) => {
    try {
      const demandId = form.getFieldValue('demandId');

      if (!demandId) {
        if (isSetFormData) {
          message.error('請輸入需求單編號');
        }
        return null;
      }

      setIsLoading(true);

      // 使用新的 loadDemandData 方法
      const success = await loadDemandData(demandId, {
        includeFileManagement: isSetFormData,
        includeVersionControl: isSetFormData
      });

      if (success) {
        message.success('查詢成功');
        return { success: true };
      } else {
        return null;
      }
    } catch (error: any) {
      console.error('查詢錯誤:', error);
      message.error('查詢發生錯誤，請稍後再試');
      return null;
    } finally {
      setIsLoading(false);
    }
  };



  const checkexistingItem = async () => {
    try {
      setIsLoading(true);

      // 檢查是否為重複編輯模式
      if (formType === "重複編輯") {
        const demandId = form.getFieldValue('demandId');
        if (demandId) {
          // 使用新的方式檢查版本控制
          const success = await handleSearch(false);
          if (success) {
            // 如果載入成功，版本控制資訊已經在 loadDemandData 中設置
            // 這裡可以進一步檢查版本限制（如果需要）
            if (currentVersionNumber >= 3) {
              message.error('此需求單已達修改上限（3次）!');
              setConfirmOpen(false);
              return;
            }
          } else {
            // 如果是重複編輯但找不到資料，設為首次填寫
            updateVersionControl({
              currentVersionNumber: 0,
              totalVersions: 0
            });
          }
        } else {
          updateVersionControl({
            currentVersionNumber: 0,
            totalVersions: 0
          });
        }
      } else {
        // 首次填寫
        updateVersionControl({
          currentVersionNumber: 0,
          totalVersions: 0
        });
      }

      // 顯示確認對話框
      setConfirmOpen(true);
    } catch (error) {
      console.error('檢查舊資料時發生錯誤:', error);
      message.error('檢查資料時發生錯誤');
      setConfirmOpen(false);
    } finally {
      setIsLoading(false);
    }
  };

  // 新增動作處理函數
  const handleAddAction = () => {
    dispatch({ type: ACTIONS.ADD_ACTION });
  };

  // 刪除動作處理函數
  const handleRemoveAction = (actionId: string) => {
    dispatch({
      type: ACTIONS.REMOVE_ACTION,
      payload: { actionId }
    });
  };

  // 更新動作處理函數
  const handleUpdateAction = (actionId: string, updates: Partial<ActionItem>) => {
    dispatch({
      type: ACTIONS.UPDATE_ACTION,
      payload: { actionId, updates }
    });
  };

  // 🎯 Form 初始化 - 改為從 state 同步到 form
  useEffect(() => {
    form.setFieldsValue({
      name: state.basic?.name,
      birthDate: state.basic?.birthDate ? dayjs(state.basic.birthDate) : null,
      gender: state.basic?.gender,
      familyName: state.basic?.familyName,
      familyPhone: state.basic?.familyPhone,
      familyEmail: state.basic?.familyEmail,
      funeralCompany: state.basic?.funeralCompany,
      funeralDate: state.basic?.funeralDate ? dayjs(state.basic.funeralDate) : null,
      publicScript: state.ceremony?.public?.script,
      familyScript: state.ceremony?.family?.script,
      farewellScript: state.ceremony?.farewell?.script,
      notes: state.notes
    });
  }, [form, state]);

  // 🎯 Form 值變化處理函數 - 改為直接使用 dispatch
  const handleFormValuesChange = useCallback((changedValues: any) => {
    Object.entries(changedValues).forEach(([field, value]) => {
      // 基本資訊字段
      if (['name', 'birthDate', 'gender', 'familyName', 'familyPhone', 'familyEmail', 'funeralDate'].includes(field)) {
        let processedValue = value;

        // 處理特殊字段
        if (field === 'birthDate' || field === 'funeralDate') {
          processedValue = value ? (value as any).format('YYYY-MM-DD') : null;
        }

        dispatch({
          type: ACTIONS.UPDATE_BASIC_FIELD,
          payload: { field, value: processedValue }
        });
      }

      // 台詞字段
      else if (['publicScript', 'familyScript', 'farewellScript'].includes(field)) {
        const sectionMap: Record<string, string> = {
          publicScript: 'public',
          familyScript: 'family',
          farewellScript: 'farewell'
        };
        dispatch({
          type: ACTIONS.UPDATE_SCRIPT,
          payload: { section: sectionMap[field], script: value as string }
        });
      }

      // 備註字段
      else if (field === 'notes') {
        dispatch({
          type: ACTIONS.UPDATE_NOTES,
          payload: value as string
        });
      }
    });
  }, [dispatch]);

  // 🎯 確認對話框內容生成函數
  const getContent = (): string => {
    if (isSaving) {
      return "儲存資料及上傳檔案中，請耐心等待\n\n⚠️ 請勿關閉瀏覽器或離開此頁面，以免資料遺失";
    }

    if (formType === "重複編輯") {
      return `※ 提醒您，每張需求單至多修改 3 次\n目前尚可使用修改次數：${3 - currentVersionNumber} 次`;
    }

    return "※ 這是您的第一次提交，確認後將建立新的需求單";
  };

  // 移除個別欄位的 initialValue
  return (
    <Spin spinning={isLoading || isSaving || isLoadingDemand} tip={isLoadingDemand ? "載入需求單數據中..." : undefined}>
      <Confirm
        open={confirmOpen}
        title="請確認是否提交需求單?"
        content={getContent()}
        isLoading={isSaving}
        onConfirm={() => isSaving ? null : handleSubmit()}
        onCancel={() => {
          updateVersionControl({
            currentVersionNumber: 0,
            totalVersions: 0
          });
          setConfirmOpen(false);
        }}
      />
      <Form
        form={form}
        onFinish={handleConfirmSubmit}
        onFinishFailed={onFinishFailed}
        onValuesChange={handleFormValuesChange}
        layout="vertical"
      >
        <Title className="!text-[22px]" level={3} style={{ textAlign: "center" }}>
          形象建立資訊填寫
        </Title>
        <Flex vertical className="gap-6" >
          {/* <FormContainer>
            <Title className="!text-[20px]" level={4}>
              需求單資訊
            </Title>
            <Row gutter={[16, 16]} className="flex flex-col gap-4">
              <Col>
                <Form.Item name="formType">
                  <Radio.Group
                    onChange={(e: RadioChangeEvent) => {
                      setFormType(e.target.value);
                      if (e.target.value === "首次填寫") {
                        form.setFieldsValue({
                          demandId: undefined
                        });
                      }
                    }}
                  >
                    <Radio className="!text-[15px] !bg-white [&_.ant-radio-checked_.ant-radio-inner]:!border-[#FFB81F] [&_.ant-radio-checked_.ant-radio-inner]:!bg-[#FFB81F]" value="首次填寫">
                      首次填寫
                    </Radio>
                    <Radio className="!text-[15px] !bg-white [&_.ant-radio-checked_.ant-radio-inner]:!border-[#FFB81F] [&_.ant-radio-checked_.ant-radio-inner]:!bg-[#FFB81F]" value="重複編輯">
                      重複編輯
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={24} className="flex flex-col">
                <div className="flex flex-col gap-2">
                  <Form.Item name="demandId">
                    <Input
                      placeholder={urlDemandId ? "系統將自動產生編號" : "請輸入需求單編號"}
                      disabled={!!urlDemandId}
                      value={urlDemandId || demandIdForModal}
                      className={urlDemandId ? "!bg-[#F5F5F5] !h-[40px] !rounded-[4px]" : "!h-[40px] !rounded-[4px]"}
                    />
                  </Form.Item>
                  {formType === "重複編輯" && (
                    <Button
                      className="!h-[40px] !rounded-[4px]"
                      onClick={() => handleSearch(true)}
                    >
                      查詢需求單
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </FormContainer> */}

          <FormContainer>
            <Title level={4} className="!text-[20px]">基本資訊</Title>
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={12} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">親友姓名</Text>
                  <Form.Item
                    name="name"
                    rules={[{ required: true, message: '請輸入親友姓名' }]}
                  >
                    <Input
                      placeholder="請輸入親友姓名"
                      className="!h-[40px] !rounded-[4px]"
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">親友出生日期</Text>
                  <Form.Item
                    name="birthDate"
                  >
                    <DatePicker
                      style={{ width: "100%", height: "40px" }}
                      placeholder="請選擇日期"
                      suffixIcon={<CalendarIcon />}
                      className="!rounded-[4px]"
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">親友性別</Text>
                  <Form.Item
                    name="gender"
                    initialValue="male"
                  >
                    <Radio.Group className="flex gap-8">
                      <Radio value="male" className="!text-[15px]">男</Radio>
                      <Radio value="female" className="!text-[15px]">女</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">家屬姓名（聯絡人）</Text>
                  <Form.Item
                    name="familyName"
                  // rules={[{ required: true, message: '請輸入家屬姓名' }]}
                  >
                    <Input
                      placeholder="請輸入家屬姓名"
                      className="!h-[40px] !rounded-[4px]"
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">家屬聯絡電話</Text>
                  <Form.Item
                    name="familyPhone"
                  >
                    <Input
                      placeholder="請輸入電話號碼"
                      className="!h-[40px] !rounded-[4px]"
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">家屬聯絡email</Text>
                  <Form.Item
                    name="familyEmail"
                    rules={[{ type: 'email', message: '請輸入有效的email格式' }]}
                  >
                    <Input
                      placeholder="請輸入email"
                      className="!h-[40px] !rounded-[4px]"
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">禮儀業者</Text>
                  <Input
                    placeholder="恆天人本"
                    disabled
                    className="!h-[40px] !rounded-[4px] !bg-[#F5F5F5]"
                  />
                </div>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">出殯日期</Text>
                  <Form.Item
                    name="funeralDate"
                  >
                    <DatePicker
                      style={{ width: "100%", height: "40px" }}
                      placeholder="請選擇日期"
                      suffixIcon={<CalendarIcon />}
                      className="!rounded-[4px]"
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8}>
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">訃聞</Text>
                  <Form.Item
                    name="obituary"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e?.fileList;
                    }}
                  >
                    <PhotoSection
                      fileBusinessObjects={state.basic.obituary}
                      uploadPhoto={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ['basic', 'obituary']
                      })}
                      removePhoto={(fileId: string) => {
                        if (state.basic.obituary.length > 0) {
                          handleRemove({
                            fileId,
                            formField: ['basic', 'obituary']
                          });
                        }
                      }}
                      allowMultiple={false}
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </FormContainer>

          <FormContainer>
            <Title level={4} className="!text-[20px]">親友影片製作</Title>

            <Row gutter={[16, 16]} className="mt-4">
              <Col span={24}>
                <Text className="!text-[15px] font-medium flex items-center gap-2">
                  <SoundIcon />
                  聲音製作
                </Text>
              </Col>

              <Col span={24} className="flex flex-col gap-2">
                <Text className="!text-[15px]">親友聲音</Text>
                <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                  ※ 提醒您 聲音檔案不可有太多雜訊、僅可以是1人在說話、音檔說話長度需超過30秒
                </Text>

                <Form.Item
                  name="voiceFile"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e?.fileList;
                  }}
                >
                  <Flex vertical className="gap-2">
                    <AudioSection
                      fileBusinessObjects={state.basic.voiceFile}
                      formField={["basic", "voiceFile"]}
                      handleUpload={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ["basic", "voiceFile"]
                      })}
                      handleRemove={(fileId: string) => {
                        if (state.basic.voiceFile.length > 0) {
                          handleRemove({
                            fileId,
                            formField: ["basic", "voiceFile"]
                          });
                        }
                      }}
                    />
                  </Flex>
                </Form.Item>

              </Col>

            </Row>

            <Divider className="!my-6" />

            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Text className="!text-[15px] font-medium flex items-center gap-2">
                  <VideoIcon />
                  影像製作
                </Text>
              </Col>

              <Col span={24} className="mt-2">
                <Text className="!text-[15px]">公祭</Text>
              </Col>

              <Col span={24} className="flex flex-col gap-2">
                <Text className="!text-[15px]">台詞</Text>
                <div className="flex gap-2 mb-2">
                  <Button
                    className="!h-[32px] !rounded-[4px]"
                    onClick={() => handleExampleClick('public', 1)}
                  >
                    範例一
                  </Button>
                  <Button
                    className="!h-[32px] !rounded-[4px]"
                    onClick={() => handleExampleClick('public', 2)}
                  >
                    範例二
                  </Button>
                </div>
                <Form.Item
                  name="publicScript"
                >
                  <Input.TextArea
                    placeholder="請輸入台詞"
                    rows={4}
                    showCount
                    maxLength={10000}
                    className="!rounded-[4px]"
                  />
                </Form.Item>
              </Col>

              <Col span={24} className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">朗讀語氣</Text>
                  <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                    ※ 提醒您 聲音檔案不可有太多雜訊、僅可以是1人在說話、音檔說話長度需超過30秒
                  </Text>
                  <Form.Item
                    name="myPublicAudio"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e?.fileList;
                    }}
                  >
                    <AudioSection
                      fileBusinessObjects={state.ceremony.public.files.my.audio}
                      formField={["ceremony", "public", "files", "my", "audio"]}
                      handleUpload={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ["ceremony", "public", "files", "my", "audio"]
                      })}
                      handleRemove={(fileId: string) => handleRemove({
                        fileId,
                        formField: ["ceremony", "public", "files", "my", "audio"]
                      })}
                    />
                  </Form.Item>
                </div>
              </Col>

              <Col span={24} className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">照片</Text>
                  <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                    ※ 提醒您 圖片解析度需達1080P以上、需為單獨照片、需為正面照片
                  </Text>
                  <Form.Item
                    name="myPublicPhoto"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e?.fileList;
                    }}
                  >
                    <PhotoSection
                      fileBusinessObjects={state.ceremony.public.files.my.photo}
                      uploadPhoto={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ['ceremony', 'public', 'files', 'my', 'photo']
                      })}
                      removePhoto={(fileId: string) => {
                        if (state.ceremony.public.files.my.photo.length > 0) {
                          handleRemove({
                            fileId,
                            formField: ['ceremony', 'public', 'files', 'my', 'photo']
                          });
                        }
                      }}
                      allowMultiple={false}
                    />
                  </Form.Item>
                </div>
              </Col>

            </Row>

            <Divider className="!my-6" />
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Text className="!text-[15px]">家祭</Text>
              </Col>
              <Col span={24} className="flex flex-col gap-2">
                <Text className="!text-[15px]">台詞</Text>
                <div className="flex gap-2 mb-2">
                  <Button
                    className="!h-[32px] !rounded-[4px]"
                    onClick={() => handleExampleClick('family', 1)}
                  >
                    範例一
                  </Button>
                  <Button
                    className="!h-[32px] !rounded-[4px]"
                    onClick={() => handleExampleClick('family', 2)}
                  >
                    範例二
                  </Button>
                </div>
                <Form.Item
                  name="familyScript"
                >
                  <Input.TextArea
                    placeholder="請輸入台詞"
                    rows={4}
                    showCount
                    maxLength={10000}
                    className="!rounded-[4px]"
                  />
                </Form.Item>
              </Col>
              <Col span={24} className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">朗讀語氣</Text>
                  <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                    ※ 提醒您 聲音檔案不可有太多雜訊、僅可以是1人在說話、音檔說話長度需超過30秒
                  </Text>
                  <Form.Item
                    name="myFamilyAudio"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e?.fileList;
                    }}
                  >
                    <AudioSection
                      fileBusinessObjects={state.ceremony.family.files.my.audio}
                      formField={["ceremony", "family", "files", "my", "audio"]}
                      handleUpload={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ["ceremony", "family", "files", "my", "audio"]
                      })}
                      handleRemove={(fileId: string) => handleRemove({
                        fileId,
                        formField: ["ceremony", "family", "files", "my", "audio"]
                      })}
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col span={24} className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">照片</Text>
                  <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                    ※ 提醒您 圖片解析度需達1080P以上、需為單獨照片、需為正面照片
                  </Text>
                  <Form.Item
                    name="myFamilyPhoto"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e?.fileList;
                    }}
                  >
                    <PhotoSection
                      fileBusinessObjects={state.ceremony.family.files.my.photo}
                      uploadPhoto={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ['ceremony', 'family', 'files', 'my', 'photo']
                      })}
                      removePhoto={(fileId: string) => {
                        if (state.ceremony.family.files.my.photo.length > 0) {
                          handleRemove({
                            fileId,
                            formField: ['ceremony', 'family', 'files', 'my', 'photo']
                          });
                        }
                      }}
                      allowMultiple={false}
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            <Divider className="!my-6" />
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Text className="!text-[15px]">遠行</Text>
              </Col>
              <Col span={24} className="flex flex-col gap-2">
                <Text className="!text-[15px]">台詞</Text>
                <div className="flex gap-2 mb-2">
                  <Button
                    className="!h-[32px] !rounded-[4px]"
                    onClick={() => handleExampleClick('farewell', 1)}
                  >
                    範例一
                  </Button>
                  <Button
                    className="!h-[32px] !rounded-[4px]"
                    onClick={() => handleExampleClick('farewell', 2)}
                  >
                    範例二
                  </Button>
                </div>
                <Form.Item
                  name="farewellScript"
                >
                  <Input.TextArea
                    placeholder="請輸入台詞"
                    rows={4}
                    showCount
                    maxLength={10000}
                    className="!rounded-[4px]"
                  />
                </Form.Item>
              </Col>
              <Col span={24} className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">朗讀語氣</Text>
                  <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                    ※ 提醒您 聲音檔案不可有太多雜訊、僅可以是1人在說話、音檔說話長度需超過30秒
                  </Text>
                  <Form.Item
                    name="myFarewellAudio"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e?.fileList;
                    }}
                  >
                    <AudioSection
                      fileBusinessObjects={state.ceremony.farewell.files.my.audio}
                      formField={["ceremony", "farewell", "files", "my", "audio"]}
                      handleUpload={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ["ceremony", "farewell", "files", "my", "audio"]
                      })}
                      handleRemove={(fileId: string) => handleRemove({
                        fileId,
                        formField: ["ceremony", "farewell", "files", "my", "audio"]
                      })}
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col span={24} className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <Text className="!text-[15px]">照片</Text>
                  <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                    ※ 提醒您 圖片解析度需達1080P以上、需為單獨照片、需為正面照片
                  </Text>
                  <Form.Item
                    name="myFarewellPhoto"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e?.fileList;
                    }}
                  >
                    <PhotoSection
                      fileBusinessObjects={state.ceremony.farewell.files.my.photo}
                      uploadPhoto={({ file }: any) => handleUpload({
                        file: file.originFileObj || file,
                        formField: ['ceremony', 'farewell', 'files', 'my', 'photo']
                      })}
                      removePhoto={(fileId: string) => {
                        if (state.ceremony.farewell.files.my.photo.length > 0) {
                          handleRemove({
                            fileId,
                            formField: ['ceremony', 'farewell', 'files', 'my', 'photo']
                          });
                        }
                      }}
                      allowMultiple={false}
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </FormContainer>

          <FormContainer>
            <Title level={4} className="!text-[20px]">親友動作製作</Title>
            <Row gutter={[16, 24]} className="mt-4">
              {state.ceremony.actions.map((action: ActionItem, index: number) => (
                <Col span={24} key={action.id}>
                  <div className="flex flex-col gap-4">
                    <div className="flex justify-between items-center">
                      <Text className="!text-[15px]">親友照片 {index + 1}</Text>
                      {index > 0 && (
                        <Button
                          danger
                          onClick={() => handleRemoveAction(action.id)}
                          icon={<DeleteOutlined />}
                        >
                          刪除動作
                        </Button>
                      )}
                    </div>

                    <div className="flex flex-col gap-2">
                      <Text type="danger" className="!text-[13px] !text-[#FF0000]">
                        ※ 提醒您 圖片解析度需達1080P以上、需為單獨照片、需為正面照片
                      </Text>
                      <Form.Item
                        name={`action${index + 1}Photo`}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          if (Array.isArray(e)) {
                            return e;
                          }
                          return e?.fileList;
                        }}
                      >
                        <PhotoSection
                          fileBusinessObjects={state.ceremony.actions[index].files.my.photo}
                          uploadPhoto={({ file }: any) => handleUpload({
                            file: file.originFileObj || file,
                            formField: ['ceremony', 'actions', index, 'files', 'my', 'photo']
                          })}
                          removePhoto={(fileId: string) => {
                            if (state.ceremony.actions[index].files.my.photo.length > 0) {
                              handleRemove({
                                fileId,
                                formField: ['ceremony', 'actions', index, 'files', 'my', 'photo']
                              });
                            }
                          }}
                          allowMultiple={false}
                        />
                      </Form.Item>
                    </div>

                    <ActionType
                      name={`action${index + 1}`}
                      title={`動作呈現 ${index + 1}`}
                      value={action.action}
                      moreText={action.moreText}
                      hint={action.hint}
                      reverseHint={action.reverseHint}
                      onActionChange={(values: ActionTypeValues) => {
                        handleUpdateAction(action.id, {
                          action: values.action,
                          moreText: values.moreText,
                          hint: values.hint,
                          reverseHint: values.reverseHint
                        });
                      }}
                    />
                  </div>
                </Col>
              ))}

              <Col span={24}>
                <Button
                  type="dashed"
                  block
                  onClick={handleAddAction}
                  icon={<PlusOutlined />}
                >
                  新增動作
                </Button>
              </Col>
            </Row>
          </FormContainer>

          <FormContainer>
            <Title level={4} className="!text-[20px]">告別式直播</Title>
            <Flex vertical className="gap-2">
              <Flex
                vertical
                className="gap-2"
              >
                <Text className="!text-[15px]">告別式直播</Text>
                <Text className="!text-[14px] !text-[#B5BEC7]">
                  ※ 全程直播告別式並提供YouTube連結及認證碼供無法前來的親戚朋友觀看
                </Text>
                <Radio.Group
                  name="live"
                  value={state.live.isEnabled}
                  onChange={(e) => {
                    dispatch({
                      type: ACTIONS.UPDATE_LIVE_STATUS,
                      payload: e.target.value
                    });
                  }}
                >
                  <Radio value={true}>需要</Radio>
                  <Radio value={false}>不需要</Radio>
                </Radio.Group>
              </Flex>
              <Flex
                vertical
                className="gap-2"
              >
                <Text className="!text-[15px]">往生親友AI互動畫面（對嘴影片及聲音）</Text>
                <Text className="!text-[14px] !text-[#B5BEC7]">
                  ※ 將作為告別式直播前的AI互動畫面
                </Text>
                <Radio.Group
                  name="liveStream"
                  value={state.ceremony.liveStream.isEnabled}
                  onChange={(e) => {
                    dispatch({
                      type: ACTIONS.UPDATE_LIVE_STREAM_STATUS,
                      payload: e.target.value
                    });
                  }}
                >
                  <Radio value={true}>需要</Radio>
                  <Radio value={false}>不需要</Radio>
                </Radio.Group>
              </Flex>
            </Flex>
          </FormContainer>

          <FormContainer>
            <Title level={4} className="!text-[20px]">親友形象問卷</Title>
            <Row gutter={[16, 16]} className="mt-4">
              <Col span={24} className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <Text className="!text-[15px]">
                  請前往表單側寫親友個性、喜好等問題，讓我們可以製作更加貼切的形象內容
                </Text>
                <Button
                  type="primary"
                  className="!h-[40px] !rounded-[4px] !bg-[#FFB81F] !text-[15px] hover:!bg-[#FFB81F]/80 w-full sm:w-auto"
                  onClick={() => window.open('https://docs.google.com/forms/d/1xOUVhsXUl7P5_-crpuHvsPOsPQMSs_y_Oyp_RVxi8Xs/viewform?pli=1&pli=1&edit_requested=true', '_blank')}
                >
                  前往問卷進行填寫
                </Button>
              </Col>
            </Row>
          </FormContainer>

          <FormContainer>
            <Title level={4}>備註</Title>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Form.Item
                  name="notes"
                >
                  <Input.TextArea
                    placeholder="請輸入備註"
                    rows={4}
                    showCount
                    maxLength={10000}
                  />
                </Form.Item>
              </Col>
            </Row>
          </FormContainer>

          {/* 費用試算區塊 */}
          {showCostCalculation && (
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <div style={{
                  backgroundColor: "#F7F4EF",
                  margin: "20px 0"
                }}>
                  <div className="flex flex-col gap-4">
                    {/* 標題 */}
                    <div className="flex justify-center items-center mb-4">
                      <h2 style={{
                        fontWeight: 600,
                        fontSize: "22px",
                        textAlign: "center",
                        letterSpacing: "0.2em",
                        color: "#3E3D3D",
                        margin: 0
                      }}>
                        費用試算
                      </h2>
                    </div>

                    {/* 費用總計區塊 */}
                    <div
                      className="bg-white bg-opacity-80 p-5 flex flex-col gap-4 rounded-md cursor-pointer hover:bg-[#FFB81F] group"
                      onClick={() => {
                        fetchPriceList();
                        setShowPricelistModal(true);
                      }}
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-1">
                          <span className="font-bold text-[16px] text-[#3E3D3D] flex items-center">費用總計</span>
                          <QuestionCircleOutlined className="text-[#FFB81F] text-lg flex items-center group-hover:text-[#3E3D3D]" />
                        </div>
                        <span className="font-bold text-[16px] text-[#3E3D3D] flex items-center">
                          {cost.total}
                        </span>
                      </div>
                    </div>

                    {/* 親友影音製作區塊 */}
                    <div className="bg-white bg-opacity-80 p-5 flex flex-col gap-4 rounded-md">
                      <div className="flex items-center">
                        <span className="font-medium text-[16px] text-[#11386F] flex items-center">親友影音製作</span>
                      </div>
                      {
                        cost.public.price > 0 && (
                          <VideoPrice title="公祭影片" cost={cost.public.price} time={cost.public.info} />
                        )
                      }
                      {
                        cost.family.price > 0 && (
                          <VideoPrice title="家祭影片" cost={cost.family.price} time={cost.family.info} />
                        )
                      }
                      {
                        cost.farewell.price > 0 && (
                          <VideoPrice title="遠行影片" cost={cost.farewell.price} time={cost.farewell.info} />
                        )
                      }
                    </div>

                    {/* 親友動作製作區塊 */}
                    <div className="bg-white bg-opacity-80 p-5 flex flex-col gap-4 rounded-md">
                      <div className="flex items-center">
                        <span className="font-medium text-[16px] text-[#11386F] flex items-center">親友動作製作</span>
                      </div>
                      {
                        cost.actions?.map((action: any, index: number) => (
                          action.info && action.price > 0 && (
                            <ActionPrice
                              key={action.id || index}
                              title={`動作${action.order}: ${action.info}`}
                              cost={action.price}
                            />
                          )
                        ))
                      }
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}

          {/* 費用試算按鈕 */}
          <Row justify="end" gutter={16} style={{ marginBottom: "20px" }}>
            <Col>
              <Button
                onClick={handleCostCalculation}
                style={{
                  backgroundColor: "#F5F5F5",
                  color: "#333",
                  borderColor: "#D9D9D9",
                  borderRadius: "4px",
                  fontWeight: 500,
                  height: "40px",
                  boxShadow: "0 2px 0 rgba(0,0,0,0.02)"
                }}
                icon={<CalculatorOutlined />}
              >
                費用試算
              </Button>
            </Col>
            <Col>
              <Button type="primary" htmlType="submit" style={{
                height: "40px",
                borderRadius: "4px",
                fontWeight: 500,
                boxShadow: "0 2px 0 rgba(0,0,0,0.1)"
              }}>提交需求</Button>
            </Col>
          </Row>

          <Pricelist
            showPricelistModal={showPricelistModal}
            setShowPricelistModal={setShowPricelistModal}
            isEditMode={false}
            priceListData={priceList}
            isLoading={isPriceListLoading}
          />
        </Flex>
      </Form>

      {/* 需求單編號提醒 Modal */}
      <Modal
        open={demandIdModalVisible}
        onCancel={() => {
          setDemandIdModalVisible(false);
          navigate('/'); // 確認後導航到服務方案頁面
        }}
        footer={[
          <Button
            key="copy"
            icon={<CopyOutlined />}
            onClick={handleCopyDemandId}
            style={{
              borderColor: "#D7862A",
              color: "#D7862A",
              fontSize: "16px",
              fontWeight: 600,
              height: "40px",
              minWidth: "100px"
            }}
          >
            複製編號
          </Button>,
          <Button
            key="confirm"
            type="primary"
            onClick={() => {
              setDemandIdModalVisible(false);
              navigate('/'); // 確認後導航到服務方案頁面
            }}
            style={{
              background: "#D7862A",
              borderColor: "#D7862A",
              fontSize: "16px",
              fontWeight: 600,
              height: "40px",
              minWidth: "100px"
            }}
          >
            我已記住
          </Button>
        ]}
        width={480}
        centered
        closable={false}
        maskClosable={false}
        styles={{
          mask: {
            backgroundColor: "rgba(0, 0, 0, 0.45)",
          },
          content: {
            borderRadius: "12px",
            padding: "32px 24px",
          },
        }}
      >
        <div className="flex flex-col items-center gap-6">
          {/* 成功圖標 */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          {/* 標題 */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              需求單提交成功！
            </h3>
            <p className="text-gray-600 mb-4">
              請記住您的需求單編號，以便後續查詢和聯繫
            </p>
          </div>

          {/* 需求單編號 */}
          <div className="w-full bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-4">
            <div className="text-center">
              <p className="text-sm text-gray-500 mb-1">需求單編號</p>
              <div className="flex items-center justify-center gap-3">
                <p className="text-2xl font-bold text-gray-800 font-mono tracking-wider">
                  {demandIdForModal}
                </p>
                <Button
                  type="text"
                  icon={<CopyOutlined />}
                  onClick={handleCopyDemandId}
                  className="!text-gray-600 hover:!text-blue-600 hover:!bg-blue-50"
                  title="複製需求單編號"
                />
              </div>
              <p className="text-xs text-gray-400 mt-2">點擊複製圖標可複製編號</p>
            </div>
          </div>

          {/* 提醒文字 */}
          <div className="text-center text-sm text-gray-500">
            <p>建議您將此編號截圖保存或記錄下來</p>
            <p>我們將盡快與您聯繫確認需求詳情</p>
          </div>
        </div>
      </Modal>

      {/* 浮動儲存按鈕 */}
      <FloatButton
        icon={<SaveOutlined />}
        type="primary"
        onClick={handleConfirmSubmit}
        tooltip="儲存需求單"
        style={{
          right: 24,
          bottom: 24,
          width: 60,
          height: 60,
          fontSize: '20px',
          backgroundColor: '#FFB81F',
          borderColor: '#FFB81F'
        }}
        className="shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
      />
    </Spin>
  );
};

const FormContainer = ({ children }: FormContainerProps): JSX.Element => {
  return (
    <Flex vertical className="p-2 md:p-6 bg-[#ffffffcc]">
      {children}
    </Flex>
  );
};

const VideoPrice = ({ title, cost, time }: VideoPriceProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <span className="text-[16px] text-[#3E3D3D] flex items-center">{title}</span>
        <span className="font-bold text-[16px] text-[#3E3D3D] flex items-center">
          {cost}
        </span>
      </div>
      <div className="flex items-center">
        <span className="text-[16px] text-[#8B8D97] flex items-center">{time}</span>
      </div>
    </div>
  );
};

const ActionPrice = ({ title, cost }: ActionPriceProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <span className="text-[16px] text-[#3E3D3D] flex items-center">{title}</span>
        <span className="font-bold text-[16px] text-[#3E3D3D] flex items-center">{cost}</span>
      </div>
    </div>
  );
};

export default DemandForm;

